import { useEffect, useRef } from 'react';

import { useAppDispatch, useAppSelector } from '@/shared/hooks';

import { ModalID, modalModel } from '@/entities/modal';
import { organizationModel } from '@/entities/organization';
import { userModel } from '@/entities/user';

export const useFDADentalProfessionalConfirmation = () => {
  const dispatch = useAppDispatch();
  const dispatchRef = useRef(dispatch);
  const hasOpenedModal = useRef(false);

  dispatchRef.current = dispatch;

  const currentUser = useAppSelector(userModel.selectors.selectCurrentUser);
  const userLoading = useAppSelector(userModel.selectors.selectLoading);
  const organizationLoading = useAppSelector(
    organizationModel.selectors.selectLoading,
  );

  const { isFDA3DGPRestrictions: isFDAOrganization } = useAppSelector(
    organizationModel.selectors.selectFDAEnvironment,
  );

  const isFDADentalProfessionalConfirmed =
    currentUser?.Settings?.FDADentalProfessionalConfirmed ?? false;

  const isDataLoaded =
    userLoading === 'succeeded' && organizationLoading === 'succeeded';

  useEffect(() => {
    if (!isDataLoaded || hasOpenedModal.current) {
      return;
    }

    const shouldShowModal =
      isFDAOrganization && !isFDADentalProfessionalConfirmed;

    if (shouldShowModal) {
      hasOpenedModal.current = true;
      dispatchRef.current(
        modalModel.actions.openModal({
          modalID: ModalID.FDADentalProfessionalConfirmationModal,
        }),
      );
    }
  }, [isDataLoaded, isFDAOrganization, isFDADentalProfessionalConfirmed]);
};
